// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"3311":"5ffe1889","7292":"dc6a055a"}[chunkId] + "." + {"3311":"6b14f1081182f95b","7292":"d95e87388592412a"}[chunkId] + ".js";
};